import React from 'react'
import ReactDOM from 'react-dom'

// Drop-in replacement for webpacker-react npm package.
// Scans DOM for elements with data-react-class and mounts them.
export default function mountComponents(components) {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-react-class]').forEach(el => {
      const name = el.dataset.reactClass
      const props = el.dataset.reactProps ? JSON.parse(el.dataset.reactProps) : {}
      const Component = components[name]
      if (Component) {
        ReactDOM.render(React.createElement(Component, props), el)
      } else {
        console.warn(`[mountComponents] Unknown component: "${name}"`)
      }
    })
  })
}
